export enum FileActionType {
  OPEN_FILE_DIALOG = 'OpenFileDialog',
  AFTER_CLOSE_FILE_DIALOG = 'AfterCloseFileDialog',
  SAVE_FILE_DIALOG = 'SaveFileAsDialog',
  SAVE_FILE_PATH_DIALOG = 'SaveFilePathDialog',
  SELECT_FILE_TO_MERGE_DIALOG = 'SelectFileToMergeDialog',
  FILE_TO_MERGE_SELECTED = 'FileToMergeSelected',
  MERGE_FILE_SAVE_DIALOG = 'MergeFileSaveDialog',
  MERGE_FILE_SAVE_PATH_SELECTED = 'MergeFileSavePathSelected',
  MERGE_FILE_SAVE_DIALOG_CANCELLED = 'MergeFileSaveDialogCancelled',
}
